export enum StatementType {
  ConsolidatedStatement = 'consolidated_statement',
  FixedIncomeStatement = 'fixed_income_statement',
  IncomeStatement = 'income_statement',
  QuarterlyCostsStatement = 'quarterly_costs_statement',
  InvestmentReport = 'investment-report'
}
